import { render, staticRenderFns } from "./setScada.vue?vue&type=template&id=74110af7&scoped=true"
import script from "./setScada.vue?vue&type=script&lang=js"
export * from "./setScada.vue?vue&type=script&lang=js"
import style0 from "./setScada.vue?vue&type=style&index=0&id=74110af7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74110af7",
  null
  
)

export default component.exports